import mapValues from 'lodash/mapValues'
import { splitAdmissionsPeriod } from '../../conduct/generators'
import { createAdmissionsSlotsFrom } from '../../mappers'
import { createRowSlotsByHealthProcedureType } from '../../mapValues'
import { groupByYear, byTypeEqualToAdmission, byTypeExceptAdmission, filterHealthProceduresPer } from '~/utils'
import { IHealthProcedures, ITimelineGeneral } from '~/interfaces'

export const mapperTimelineViewByYearsFrom = (
  healthProcedures: IHealthProcedures[]
): ITimelineGeneral.IYearTimelineData => {
  const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
  const admissions = filterHealthProceduresPer(healthProcedures, byTypeEqualToAdmission)

  const admissionSlots = createAdmissionsSlotsFrom(admissions, healthProceduresWithoutAdmissions)
  const splitAdmissionsSlotsPerYear = splitAdmissionsPeriod(admissionSlots, 'years')

  const groupedByYear = groupByYear([...healthProceduresWithoutAdmissions, ...splitAdmissionsSlotsPerYear])

  const groupedYearsStructured = mapValues(
    groupedByYear,
    (groupedHealthProcedure: IHealthProcedures[], key: string) => {
      const groupByType = createRowSlotsByHealthProcedureType(groupedHealthProcedure)

      return {
        id: key,
        date: new Date(Number(key), 0, 1).toISOString(),
        yearRowSlotsTotal: groupedHealthProcedure.length,
        rowSlots: Object.values(groupByType) as ITimelineGeneral.ISlot[]
      }
    }
  ) as ITimelineGeneral.IYearsRowSlotsWrapper

  return {
    timelineId: new Date(healthProcedures[0]?.startDate).getTime(),
    years: Object.values(groupedYearsStructured).reverse()
  }
}
